<script lang="ts" setup>
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout, ErrorScreenLayout, SupportEmailLink } from '@Shared';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import useCompanyName from '@Use/useCompanyName';
import BlockedGraphic from '@Assets/images/blocked.svg';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const { companyName } = useCompanyName('Your title company');
</script>

<template>
    <showcase-layout
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-feature-logo
        show-powered-by
        :show-back-button="false"
    >
        <error-screen-layout
            :image="BlockedGraphic"
            image-alt="Request blocked"
            title="We couldn't complete your request"
            image-width="9.25rem"
            image-height="9.25rem">
            <p>
                To protect you and your transaction, access to this request has been blocked.
            </p>
            <p>
                {{ companyName }} has been notified. They will reach out directly with next steps.
                If you have any technical issues, please contact <support-email-link />.
            </p>
        </error-screen-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;
</style>
